<template>
  <div :class="name">{{ $t('module_ad_type_manully_choose_creative_header') }}</div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';

const name = 'ttam-ad-format-manually-choose-header';

export default defineComponent({
  name,
  props: {},
  setup() {
    return {
      name,
    };
  },
});
</script>

<style lang="scss" scope>
.ttam-ad-format-manually-choose-header {
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  color: #8a8a8a;
  margin-bottom: 8px;
}
</style>
